import React from "react";
import { Link } from "react-router-dom";
import logo from "../../Asstes/Images/pros-logo.png";
import fbIcon from "../../Asstes/Images/fb-icon-1.svg";
import linkedinIcon from "../../Asstes/Images/lin-icon-1.svg";
import instaIcon from "../../Asstes/Images/insta-icon-1.svg";
import twitterIcon from "../../Asstes/Images/twitter-icon-1.svg";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <section className="footer-sec">
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-col logo-col">
            <img src={logo} alt="ProSapiens Logo" className="logo" />
          </div>

          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <Link to="/" onClick={scrollToTop}>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/blog" onClick={scrollToTop}>
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={scrollToTop}>
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>About</h4>
            <ul>
              <li>
                <Link to="/about" onClick={scrollToTop}>
                  About ProSapiens
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>For Companies</h4>
            <ul>
              <li>
                <Link to="/hire-about-prosapiens" onClick={scrollToTop}>
                  Hire on ProSapiens
                </Link>
              </li>
              <li>
                <Link to="/process" onClick={scrollToTop}>
                  Process
                </Link>
              </li>
              <li>
                <Link to="/blog-resources" onClick={scrollToTop}>
                  Blog/Resources
                </Link>
              </li>
              <li>
                <Link to="/company-reviews" onClick={scrollToTop}>
                  Reviews
                </Link>
              </li>
              <li>
                <Link to="/company-1-program" onClick={scrollToTop}>
                  1% Program
                </Link>
              </li>
              <li>
                <Link to="/company-remote-program" onClick={scrollToTop}>
                  Remote Program
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>For Jobseekers</h4>
            <ul>
              <li>
                <Link to="/openings" onClick={scrollToTop}>
                  Openings
                </Link>
              </li>
              <li>
                <Link to="/jobseekers-reviews" onClick={scrollToTop}>
                  Reviews
                </Link>
              </li>
              <li>
                <Link to="/jobseekers-blog" onClick={scrollToTop}>
                  Blog/Resources
                </Link>
              </li>
              <li>
                <Link to="/jobseekers-1-program" onClick={scrollToTop}>
                  1% Program
                </Link>
              </li>
              <li>
                <Link to="/jobseekers-remote-program" onClick={scrollToTop}>
                  Remote Program
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Services</h4>
            <ul>
              <li>
                <Link to="/recruitment" onClick={scrollToTop}>
                  Recruitment
                </Link>
              </li>
              <li>
                <Link to="/learning-development" onClick={scrollToTop}>
                  Learning & Development
                </Link>
              </li>
              <li>
                <Link to="/organizational-development" onClick={scrollToTop}>
                  Organizational Development
                </Link>
              </li>
              <li>
                <Link to="/hr-outsourcing" onClick={scrollToTop}>
                  HR Outsourcing
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-col contact-col">
            <a href="/contact" className="call-button">
              {" "}
              Request a Call →
            </a>
            {/* <Link to="/contact" className="call-button">
              Request a Call →
            </Link> */}

            <p>+91 95680 02281</p>
            <p>
              <a href="mailto:info@prosapiens.in">info@prosapiens.in</a>
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="social-icons">
            <a href="https://www.facebook.com/Pro.sapiens043">
              <img src={fbIcon} alt="Facebook" />
            </a>
            <a href="https://www.linkedin.com/company/prosapiens1/">
              <img src={linkedinIcon} alt="LinkedIn" />
            </a>
            <a href="https://www.instagram.com/prosapienshyd/">
              <img src={instaIcon} alt="Instagram" />
            </a>
            {/* <a href="#">
              <img src={twitterIcon} alt="Twitter" />
            </a> */}
          </div>
          <div className="footer-links">
            <Link to="/privcy-policy" onClick={scrollToTop}>
              Privacy Policy
            </Link>
            <span>|</span>
            <Link to="/term-and-condition" onClick={scrollToTop}>
              Terms & Conditions
            </Link>
          </div>
        </div>
      </footer>
    </section>
  );
};

export default Footer;
